<div class="card h-100">

    <div class="card-body">

        <p>Ponemos a tu disposición todos los medios que nos son posibles para poder atender tus preguntas y resolver todas tus dudas de la mejor y más cercana manera posible.</p>

        <mat-list>

            <mat-list-item>
                <mat-icon matListIcon>phone</mat-icon>
                <h3 class="font-weight-bold" matLine>{{ phoneNormal }}</h3>
                <p matLine>
                    <span>Horario de atención: {{ scheduleNormal }}</span>
                </p>
            </mat-list-item>

            <mat-list-item>
                <mat-icon matListIcon>email</mat-icon>
                <h3 class="font-weight-bold" matLine>
                    <a href="mailto:{{mail}}" target="_blank" class="text-dark">
                        {{mail}}
                    </a>
                </h3>
            </mat-list-item>

        </mat-list>

        <div class="alert alert-warning" role="alert">
            <h4 class="card-text mb-0">
                Disponible sólo durante la impartición del campus:
            </h4>
            <mat-list>
                <mat-list-item>
                    <mat-icon matListIcon>phone</mat-icon>
                    <p class="font-weight-bold" matLine>{{ phoneCampus }}</p>
                    <p matLine>
                        <span>Horario de atención: {{ scheduleCampus }}</span>
                    </p>
                </mat-list-item>
                <mat-list-item>
                    <mat-icon matListIcon>business</mat-icon>
                    <h3 class="font-weight-bold" matLine>{{ office }}</h3>
                </mat-list-item>
            </mat-list> 
        </div>

        <div>

            <div class="embed-responsive embed-responsive-21by9" *ngIf="mapLocation">

                <iframe 
                    [src]="mapLocation"
                    class="embed-responsive-item"
                    width="100%" 
                    height="300" 
                    scrolling="no" 
                    marginheight="0" 
                    marginwidth="0">
                </iframe>
                
            </div>

        </div>

    </div>
    
</div>
